jQuery("html").removeClass("no-js").addClass("js");

// setup.scss uses this.
import "what-input";

// TODO: This seems like a polyfill for loading="lazy" but
// it also does something stupid not using CSS. Remove
// once merged with ShortPixel AI branch
//import "./vendor/lazysizes.js";

import "./base/ajax-alert.js"; // every page
// require("../base/audience-nav.js");
import "./base/background.js"; // background-video.php
import "./base/carousel.js"; // homepage_events, homepage_news, etc
// require("../base/equalize.js");
// require("../base/lightbox.js");
import "./base/logo-scroll.js"; // header
import "./base/menu.js"; // menu.php
import "./base/nav.js"; // basic.php
import "./base/news-search.js"; // News Search
// require("../base/page-video.js");
import "./base/page.js"; // every page
import "./base/search-menu.js"; // search-menu.php
import "./base/sub-nav.js"; // sub.php
import "./base/swap.js"; // every page
import "./base/video-appender.js"; // media_gallery_set, media_gallery
import "./modules/accordion.js"; // accordion.php
import "./modules/cookieconsent-config.js"; // every page
import "./modules/home.js"; // page-home.php
import "./modules/interior.js"; // sub.php
import "./modules/media-gallery-featured.js"; // media_gallery_set
import "./modules/media-gallery.js"; // media_gallery.php
import "./modules/media-top.js"; // media-top.php
import "./modules/quick-links.js"; // quick-links.php
import "./modules/share-tools.js"; // share.php
import "./modules/logo_grid.js"; // logo_grid.php
import "./modules/block_callouts.js" // block_callouts
import "./modules/topic_image.js" // topic_image (topic media)
import "./modules/thermometer.js" // thermometer.php
import "./modules/department-item.js" // department-item.php
import "./modules/shuttle-schedule.js" //shuttle-schedule.php
import "./modules/image_fade_in.js" //image.php
import "./modules/number_stats_card_row.js" //stats_card_row.php
// require("../modules/video-appender.js"); // hidden behind base/video-appender.js
import "./modules/featured_headlines.js" // feature news headlines
